import api from "#root/store/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataApiResponse } from "./types";
import { PERSONS_KEY } from "#root/queries/persons";
import { FAMILY_ASSISTANCE_KEY } from "#root/queries/familyAssistance";

const MEDIA_KEY = 'media';

export interface MediaFile {  
  id?: string;
  name?: string;  
  referenceId?: string;  
  referenceType?: string;
  kind?: string;
  mediaContentType?: string;  
  url?: string;
}

export interface FileUploadParams {
  referenceId: string;
  referenceType: string;
  kind: string;
  file: File; // defines name and type 
}

export const useUploadFiles = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (params: FileUploadParams[]) => {
      const formData = new FormData();
      
      params.forEach((param, index) => {
        formData.append(`Requests[${index}].File`, param.file);
        formData.append(`Requests[${index}].ReferenceId`, param.referenceId);
        formData.append(`Requests[${index}].ReferenceType`, param.referenceType);
        formData.append(`Requests[${index}].Kind`, param.kind);
        formData.append(`Requests[${index}].Name`, param.file.name);
        formData.append(`Requests[${index}].Type`, param.file.type);
      });
      
      const response = await api.media.upload({ data: formData });
      return response.data as DataApiResponse<string[]>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDIA_KEY] });
    }
  });
};

export const useDeleteFiles = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (ids: string[]) => {
      const response = await api.media.delete({ 
        data: { Ids: ids }
      });
      return response.data as DataApiResponse<any>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDIA_KEY] });
      queryClient.invalidateQueries({ queryKey: [FAMILY_ASSISTANCE_KEY] });
      queryClient.invalidateQueries({ queryKey: [PERSONS_KEY] });
    }
  });
};
